import ctl from '@netlify/classnames-template-literals';

const listItemStyle = ctl(`
  flex 
  justify-between 
  items-center 
  py-2 
  border-b 
  border-light-gray
`);

const titleStyle = ctl(`
  font-bold
  font-medium 
  text-gray-700
`);

const valueStyle = ctl(`
  text-gray-900
`);

export default {
  listItemStyle,
  titleStyle,
  valueStyle,
};
